module.exports = __webpack_public_path__ + "static/joeCube-62feaf146be307ad51074604a02617b1.jpg";